<template>
  <div>
    <div class="ui secondary three item menu">
      <a class="item"
         @click="getRPDs(year-2)"
      >
        Рабочие программы {{ year-2 }} года
      </a>
      <a class="item"
         @click="getRPDs(year-1)"
      >
        Рабочие программы {{ year-1 }} года
      </a>
      <a class="active item"
         @click="getRPDs(year)"
      >
        Рабочие программы {{ year }} года
      </a>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="copy outline icon"></i>
      Шаблоны
    </h4>
    <div class="ui styled fluid accordion" >
      <div v-for="prog in samples">
        <div class="title">
          <tr>
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.main_info.discipline }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpd_sample)" type="checkbox" name="example" v-model="prog.rpd_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="times icon"></i>
      Отклонено
    </h4>
    <div class="ui styled fluid accordion" style="color: red">
      <div v-for="prog in decline">
        <div class="title">
          <tr style="color: red">
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.main_info.discipline }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Отправленно на согласование</h4></td>
            <td width="9%" style="color: black">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpd_sample)" type="checkbox" name="example" v-model="prog.rpd_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button positive" v-on:click="editRPD(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу
            </button>
            <button class="ui right floated button red" v-on:click="deleteRPD(prog.id)">
              <i class="trash icon"></i>
              Удалить рабочую программу
            </button>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="archive icon"></i>
      Готовы
    </h4>
    <div class="ui styled fluid accordion" >
      <div v-for="prog in ready">
        <div class="title">
          <tr>
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.main_info.discipline }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="((prog.main_info.speciality_code === '13.03.01' || (prog.main_info.speciality_code === '13.03.02' && prog.main_info.profile === 'Электроэнергетика')) && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика') || (prog.main_info.speciality_code === '21.05.02' || prog.main_info.speciality_code === '40.03.01') && (prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || (prog.main_info.speciality_code === '38.05.01' || prog.main_info.speciality_code === '20.03.01') && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика' && prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || prog.main_info.speciality_code === '44.03.02' || prog.main_info.speciality_code === '38.05.02') && prog.has_z_part === false && prog.main_info.edu_form === 'Очная'" class="big pencil alternate icon" style="color: red"></i>
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Отправленно на согласование</h4></td>
            <td width="9%" style="color: black">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div v-if="((prog.main_info.speciality_code === '13.03.01' || (prog.main_info.speciality_code === '13.03.02' && prog.main_info.profile === 'Электроэнергетика')) && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика') || (prog.main_info.speciality_code === '21.05.02' || prog.main_info.speciality_code === '40.03.01') && (prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || (prog.main_info.speciality_code === '38.05.01' || prog.main_info.speciality_code === '20.03.01') && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика' && prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || prog.main_info.speciality_code === '44.03.02' || prog.main_info.speciality_code === '38.05.02') && prog.has_z_part === false && prog.main_info.edu_form === 'Очная'" class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpd_sample)" type="checkbox" name="example" v-model="prog.rpd_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
            <div class="ui large red label">Нельзя отправить на рассмотрение Без заочной формы</div>
          </div>
          <div v-else class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpd_sample)" type="checkbox" name="example" v-model="prog.rpd_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
            <div class="ui fitted toggle checkbox">
              <input @change="sendToConsidered(prog.id, prog.considered)" type="checkbox" name="example" v-model="prog.considered">
              <label></label>
            </div>
            <div class="ui large brown label">На рассмотрении</div>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button positive" v-on:click="editRPD(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу
            </button>
            <button class="ui right floated button red" v-on:click="deleteRPD(prog.id)">
              <i class="trash icon"></i>
              Удалить рабочую программу
            </button>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="eye icon"></i>
      На рассмотрении
    </h4>
    <div class="ui styled fluid accordion" >
      <div v-for="prog in consideration">
        <div class="title">
          <tr>
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.main_info.discipline }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="((prog.main_info.speciality_code === '13.03.01' || (prog.main_info.speciality_code === '13.03.02' && prog.main_info.profile === 'Электроэнергетика')) && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика') || (prog.main_info.speciality_code === '21.05.02' || prog.main_info.speciality_code === '40.03.01') && (prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || (prog.main_info.speciality_code === '38.05.01' || prog.main_info.speciality_code === '20.03.01') && (prog.main_info.discipline !== 'Спортивные игры' && prog.main_info.discipline !== 'Общая физическая подготовка' && prog.main_info.discipline !== 'Легкая атлетика' && prog.main_info.discipline !== 'Python. Анализ данных' && prog.main_info.discipline !== 'Компьютерная графика') || prog.main_info.speciality_code === '44.03.02' || prog.main_info.speciality_code === '38.05.02') && prog.has_z_part === false && prog.main_info.edu_form === 'Очная'" class="big pencil alternate icon" style="color: red"></i>
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Отправленно на согласование</h4></td>
            <td width="9%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td width="19%">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpd_sample)" type="checkbox" name="example" v-model="prog.rpd_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
            <div class="ui fitted toggle checkbox">
              <input @change="sendToConsidered(prog.id, prog.considered)" type="checkbox" name="example" v-model="prog.considered">
              <label></label>
            </div>
            <div class="ui large brown label">На рассмотрении</div>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button positive" v-on:click="editRPD(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу
            </button>
            <button class="ui right floated button red" v-on:click="deleteRPD(prog.id)">
              <i class="trash icon"></i>
              Удалить рабочую программу
            </button>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui horizontal divider header" >
      <i class="check icon"></i>
      Согласовано
    </h4>
    <div class="ui styled fluid accordion" style="color: green">
      <div v-for="prog in acceptList">
        <div class="title">
          <tr style="color: green">
            <td width="5%">
              {{ prog.id }}
            </td>
            <td width="1%">
              <i class="dropdown icon"></i>
            </td>
            <td width="30%">
              {{ prog.main_info.discipline }}
            </td>
            <td width="30%">
              {{ prog.main_info.speciality }}
            </td>
            <td width="15%">
              {{ prog.main_info.profile }}
            </td>
            <td width="5%">
              {{ prog.main_info.year }}
            </td>
            <td width="14%">
              <i v-if="prog.library_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.library_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus square big icon" style="color: grey"></i>
              <i v-if="prog.software_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.software_agreed === false" class="times big square icon"style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.department_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.department_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
              <i v-if="prog.umu_agreed === true" class="check big square icon" style="color: green"></i>
              <i v-else-if="prog.umu_agreed === false" class="times big square icon" style="color: red"></i>
              <i v-else class="minus big square icon" style="color: grey"></i>
            </td>
          </tr>
        </div>
        <div class="content">
          <tr>
            <td width="15%"><h4>Согласованно</h4></td>
            <td width="9%" style="color: black">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
            <td width="19%">
              <h4>
                Согласованно Библиотекой
                <i v-if="prog.library_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.library_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно ЦЦТиТО
                <i v-if="prog.software_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.software_agreed === false" class="times square icon"style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно Вып.Кафедрой
                <i v-if="prog.department_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.department_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
            <td width="19%">
              <h4>
                Согласованно УМУ
                <i v-if="prog.umu_agreed === true" class="check square icon" style="color: green"></i>
                <i v-else-if="prog.umu_agreed === false" class="times square icon" style="color: red"></i>
                <i v-else class="minus square icon" style="color: grey"></i>
              </h4>
            </td>
          </tr>
          <tr>
            <td width="15%"></td>
            <td width="9%"></td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.library_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.software_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.department_comment}}
            </td>
            <td width="19%" style="color: black">
              <h4>Комментарий</h4>
              {{prog.umu_comment}}
            </td>
          </tr>
          <div class="ui fitted divider"></div>
          <div class="inline fields">
            <div class="ui fitted toggle checkbox">
              <input @change="useSample(prog.id, prog.rpd_sample)" type="checkbox" name="example" v-model="prog.rpd_sample">
              <label></label>
            </div>
            <div class="ui large blue label">Использовать в качестве шаблона</div>
          </div>
          <div class="ui fitted divider"></div>
          <div v-if="new Date(prog.created_at).getFullYear() === new Date().getFullYear()">
            <button class="ui button positive" v-on:click="editRPD(prog.id)">
              <i class="edit icon"></i>
              Редактировать рабочую программу(необходимо согласовывать заново)
            </button>
          </div>
          <div class="ui fitted divider"></div>
          <div>
            <button class="ui button blue" v-on:click="showRPD(prog.id)">
              <i class="eye icon"></i>
              Посмотреть
            </button>
            <button class="ui right floated button brown" v-on:click="getThemes(prog, 1)">
              <i class="file pdf outline icon"></i>
              Сформировать PDF
            </button>
            <button class="ui right floated button brown" v-on:click="MakeSupplementPDF(prog)">
              <i class="file pdf outline icon"></i>
              Сформировать лист дополнения
            </button>
            <button class="ui right floated button brown" v-on:click="getThemes(prog, 2)">
              <i class="file pdf outline icon"></i>
              Сформировать аннотацию
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="ui modal" id="delete_modal">
      <div class="ui header">Удалить рабочую программу дисциплин?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <p>Подтвердите удаление</p>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui negative button">
          Нет
        </div>
        <div class="ui positive right labeled icon button">
          Да
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import htmlToText from "html-to-text";
import competitionsMixin from "../mixins/competitionsMixin";
import computedMixin from "../mixins/computedMixin";
import dataRpdMixin from "../mixins/dataRpdMixin";
import _ from 'lodash';
import rpd_pdf from "../../../../makepdfs/programms/rpd_pdf";
import rpd_spo_pdf from "../../../../makepdfs/programms/rpd_spo_pdf";
import rpd_supplement_pdf from "../../../../makepdfs/programms/rpd_supplement_pdf";
import rpd_anotation_pdf from "../../../../makepdfs/programms/rpd_anotation_pdf";

export default {
  name: "index_rpd",
  mixins: [competitionsMixin, computedMixin, dataRpdMixin],
  data: () => ({
    year: new Date().getFullYear(),
    rpd: [],
    ready: [],
    consideration: [],
    accepting: [],
    decline: [],
    samples: [],
    themes: [],
  }),
  computed: {
    acceptList: function () {
      this.consideration = [];
      this.accepting = [];
      this.decline = [];
      this.samples = [];
      this.ready =[];
      this.rpd.forEach(prog=>{
        if (prog.rpd_sample === true) {
          this.samples.push(prog);
        }
        if (prog.library_agreed === true && prog.software_agreed === true && prog.umu_agreed === true){
          this.accepting.push(prog);
        }
        else if (prog.library_agreed === false || prog.software_agreed === false || prog.umu_agreed === false || prog.department_agreed === false){
          this.decline.push(prog);
        }
        else {
          if (prog.considered === false)
          {
            this.ready.push(prog);
          }
          else{
            this.consideration.push(prog);
          }
        }
      })
      return this.accepting;
    },
  },
  methods: {
    getRPDs(year) {
      axios({
        method: 'get',
        url: `rpd/year/${year}`
      }).then((response) => {
        this.rpd = response.data.rpd
        this.rpd.sort(function(a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    editRPD(id){
      location.assign(`/programms/rpd/${id}/edit`)
    },
    showRPD(id){
      location.assign(`/programms/rpd/${id}`)
    },
    deleteRPD(id){
      $('#delete_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          axios({
            method: 'get',
            url: `/programms/destroy_rpd/${id}`
          }).then((response) => {
            this.getRPDs(this.year);
          }).catch((error) => {
            return error;
          });
        }
      }).modal('show');
    },
    useSample(id, rpd_sample){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpd/' + id,
        data: {
          data: {
            rpd_sample: rpd_sample,
          }
        }
      }).then((response) => {

      }).catch((error) => {
        return error;
      });
    },
    sendToConsidered(id, considered){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpd/' + id,
        data: {
          data: {
            considered: considered,
          }
        }
      }).then((response) => {

      }).catch((error) => {
        return error;
      });
    },
    getThemes(prog, param){
      axios({
        method: 'get',
        url: `/programms/get_themes/${prog.id}`,
      }).then((response) => {
        this.themes = response.data.themes;
        this.sortThemes()
        if (param === 1){
          if (prog.main_info.speciality_code.split('.')[1] === '02'){
            rpd_spo_pdf.MakePDF(prog, this.spo_control, this.spo_times, this.o_lectureTime, this.o_practiceTime, this.o_laboratoryTime, this.o_ikrTime,
                this.o_ktoTime, this.o_keTime, this.o_lessonTime, this.o_seminarTime, this.o_controlTime, this.o_indepTime, this.o_lectures, this.o_lesson,
                this.o_seminar, this.o_practice, this.o_laboratory, this.o_indepWork, this.o_themes)
          }
          else{
            rpd_pdf.MakePDF(prog,this.o_lectureTime, this.o_practiceTime, this.o_laboratoryTime, this.o_ikrTime,
                this.o_ktoTime, this.o_keTime, this.o_lessonTime, this.o_seminarTime, this.o_controlTime, this.o_indepTime, this.o_lectures, this.o_lesson,
                this.o_seminar, this.o_practice, this.o_laboratory, this.o_indepWork, this.z_control, this.z_times, this.z_lectureTime, this.z_practiceTime,
                this.z_laboratoryTime, this.z_ikrTime, this.z_ktoTime, this.z_keTime, this.z_controlTime, this.z_indepTime, this.z_indepWork, this.o_themes, this.z_themes)
          }
        }
        else if(param === 2){
          rpd_anotation_pdf.MakePDF(prog, this.o_themes)
        }
      }).catch((error) => {
        return error;
      });
    },
    sortThemes(){
      this.themes.sort(function(a, b) {
        return a.num - b.num;
      });
    },
    MakeSupplementPDF(prog) {
      rpd_supplement_pdf.MakePDF(prog)
    },
  },
  mounted() {
    this.getRPDs(this.year)
  }
}

</script>

<style scoped>
  .accordion{
    animateChildren: false
  }

</style>